// oxlint-disable require-await
import {
  DeleteGfrDialog,
  getDeleteGfrDialogId,
} from '@/modules/patients/components/patient-details/gft-lab/dialogs/delete-gfr-dialog'
import {useConfirmGfrDoseChange} from '@/modules/patients/components/patient-details/gft-lab/dialogs/gfr-dose-change-dialog'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {Patient, PatientGfr} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {toaster} from '@cypro/ui/toaster'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeletePatientGfr() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.patients.deleteGfr(payload), async mutation => await mutation.server),
    [zero]
  )
}

/** Asks for confirmation and deletes the GFR value; resolves to true when it was deleted. */
export function useConfirmDeletePatientGfr(patient: Patient) {
  const {t} = useTranslate('common')
  const deleteGfr = useDeletePatientGfr()
  const confirmGfrDoseChange = useConfirmGfrDoseChange(patient)

  return useCallback(
    async (gfr: PatientGfr) => {
      const confirmed: unknown = await dialog.open(getDeleteGfrDialogId(gfr.id), {
        children: <DeleteGfrDialog gfr={gfr} />,
      })
      if (confirmed !== true) return false
      if (!(await confirmGfrDoseChange({deleteId: gfr.id}))) return false

      const deleteRes = await deleteGfr({id: gfr.id})
      if (!deleteRes || deleteRes.type === 'error') return false

      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
      return true
    },
    [t, deleteGfr, confirmGfrDoseChange]
  )
}
